import React from "react"
import { isEmpty } from "lodash"
import "./_style.scss"
import { GatsbyImage, getImage } from "gatsby-plugin-image";

// Atoms
import HeroContent from "§/src/components/atoms/content/hero-content"

const EditorialBanner = props => {
  const editorialBanner = props.data[0]

  // set component class
  const compClassName = "editorial-banner"
  const compClass =
    props?.className !== undefined
      ? compClassName + " " + props?.className
      : compClassName

  const imageDesktop = editorialBanner?.size === "big" ? editorialBanner?.image?.gatsbyImageBig : editorialBanner?.image
  const imageMobile = editorialBanner?.imageMobile ?? editorialBanner?.image
  const imageMobileAlt = editorialBanner?.imageMobile?.altText ?? editorialBanner?.image?.altText

  return !isEmpty(editorialBanner) ? (
    <div comp={compClassName} className={compClass + " " + props.template}>
      <div className="banner">
        <div className="banner-image">
          {editorialBanner.image && (
            <GatsbyImage
              className="sw-image d-none d-sm-block w-100"
              image={ getImage(imageDesktop) }
              objectFit="cover"
              objectPosition="right center"
              alt={editorialBanner.image?.altText || "Gefran" }
            />
          )}

          {imageMobile && (
            <GatsbyImage
              className="sw-image d-sm-none w-100"
              image={ getImage(imageMobile) }
              objectFit="cover"
              objectPosition="center bottom"
              alt={imageMobileAlt || "Gefran" }
            />
          )}
        </div>

        <HeroContent
          data={editorialBanner}
        />
      </div>
    </div>
  ) : (
    ""
  )
}

export default EditorialBanner
